import { useCallback } from "react";

import { createError, parseGraphQLError } from "utils";

import { useQuery } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

function useGetPracticeInfo() {
  const queryFactory = useCallback(() => {
    const query = `query getPractice {
                      practice {
                          id
                          name
                          isBillable
                          accountOwner {
                              id
                              name
                          }
                      }
                      me {
                          isAccountOwner
                      }
                  }`;

    const resolver = ({ data }) => {
      return {
        practice: data.practice,
        isAccountOwner: data.me.isAccountOwner,
      };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { loading, data, error, numOfFetches } = useQuery(queryFactory);

  const generateErrorMsg = useCallback(() => {
    return createError({
      ...parseGraphQLError(error),
      name: "GetPracticeInfo",
      defaultMessage:
        "We could not load your practice information at the moment. Please try again later or contact support for assistance.",
    }).message;
  }, [error]);

  return {
    loading: loading || (numOfFetches === 0 && !error),
    info: data,
    error: error && !loading ? generateErrorMsg() : null,
  };
}

export default useGetPracticeInfo;
